import {explorerSvg as Icon__small__explorerSvg} from '../Icon__small/Icon__small--explorer.js'

export var explorer = {
  name: 'explorer',
  category: 'icon',
  colorable: true,
  svg: Icon__small__explorerSvg,
};
